import { LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface BkProgressBarProps {
  activeIndex: number;
  /** Total number of steps in the current workflow. Defaults to 5. */
  totalSteps?: number;
}

const BkProgressBar: React.FC<BkProgressBarProps> = ({ activeIndex, totalSteps = 5 }) => {
  const [progress, setCurrentProgress] = useState(5);

  const calculateProgress = (totalSteps: number) => {
    // Ensure currentStep is within the valid range (1 to totalSteps)
    let currentStep = Math.max(1, Math.min(activeIndex + 1, totalSteps));

    // Calculate progress in the range [0.1, 1]
    const progress = Math.ceil((currentStep / totalSteps) * 100);

    setCurrentProgress(progress);
  };

  useEffect(() => {
    calculateProgress(totalSteps);
  }, [activeIndex, totalSteps]);

  return (
    <LinearProgress
      variant='determinate'
      value={progress}
      sx={{
        marginTop: '1.25rem',
        borderRadius: '1.25rem',
        backgroundColor: '#f0f6ff',
        '& .MuiLinearProgress-bar': {
          borderRadius: '1.25rem',
          backgroundColor: '#436eb2',
        },
      }}
    />
  );
};

export default BkProgressBar;
